import { render, staticRenderFns } from "./mailSubscription.vue?vue&type=template&id=5a0659a8&scoped=true"
import script from "./mailSubscription.vue?vue&type=script&lang=js"
export * from "./mailSubscription.vue?vue&type=script&lang=js"
import style0 from "./mailSubscription.vue?vue&type=style&index=0&id=5a0659a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0659a8",
  null
  
)

export default component.exports